query getRetailerSearch(
  $brand: CatalogChannel!
  $language: String!
  $latitude: String!
  $longitude: String!
  $unit: String!
  $distance: String!
  $retailerTypes: [String]
  $partnerTypes: [String]
  $query: String
  $articleNumbers: String
  $availabilityStatus: String
  $campaignRetailer: Boolean
  $hiddenRetailers: Boolean
  $division: String
  $distributionChannel: String
) {
  getRetailerSearch(
    brand: $brand
    language: $language
    latitude: $latitude
    longitude: $longitude
    unit: $unit
    distance: $distance
    retailerTypes: $retailerTypes
    partnerTypes: $partnerTypes
    query: $query
    articleNumbers: $articleNumbers
    availabilityStatus: $availabilityStatus
    campaignRetailer: $campaignRetailer
    hiddenRetailers: $hiddenRetailers
    division: $division
    distributionChannel: $distributionChannel
  ) {
    RecordCount

    GroupsRetailerType {
      Name
      SubGroup {
        Elements {
          Name
          RecordCount
        }
      }
    }

    Retailers {
      Distance
      Unit

      AvailabilityStatus

      Retailer {
        Address {
          AddressLines
          City
          Continent
          CountryCode
          Latitude
          Longitude
          PostalCode
        }

        Contact {
          ContactPerson
          Email
          Fax
          OnlineShopUrl
          Phone
          Url
        }

        Names
        PartnerType
        RetailerId
        RetailerType
        RetailerTypeList
      }
    }

    AvailabilityStatus {
      Name
      RecordCount
      Selected
    }
  }
}
